import React, { memo } from 'react'
import { Autocomplete } from 'components/forms/autocomplete/DPLAutocomplete'
import ClearIcon from 'transfix-icons/build/ClearIcon'
import { IconButton } from 'transfix-ui/components/IconButton'
import {
  ISpotBiddingConfig,
  IShipperApplication,
} from 'apps/spot-quote-control-panel/types/spotBiddingConfig'

interface IShipperMultiSelectProps {
  shipperApplications: IShipperApplication[]
  onChange(change: Partial<ISpotBiddingConfig>): void
}

export const ShipperMultiSelect = memo<IShipperMultiSelectProps>(
  ({ onChange, shipperApplications }) => {
    const addShipperHandler = ({
      fullSelection,
      value: id,
    }: {
      value: string
      fullSelection?: { name: string }
    }) => {
      if (id && !shipperApplications.some(shipper => shipper.id === id)) {
        onChange({
          shipperApplications: [...shipperApplications, { id, name: fullSelection?.name || '' }],
        })
      }
    }

    const handleRemove = (id: string) => {
      onChange({
        shipperApplications: shipperApplications.filter(shipper => shipper.id !== id),
      })
    }
    const sortedShipperList = shipperApplications.sort((a, b) => (a.name > b.name ? 1 : -1))

    return (
      <>
        <div className='row'>
          <div className='col-md-6 col-xs-4'>
            <Autocomplete
              label='Select Shipper(s)'
              placeholder='Enter shipper name'
              value=''
              onChange={addShipperHandler}
              type='shipper'
              dataTest='modal-shipper-name'
              large
            />
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12'>
            <ul className='shipper-list'>
              {sortedShipperList.map(shipper => (
                <li key={shipper.id} className='shipper-list-item'>
                  <span>{shipper.name}</span>
                  <IconButton
                    Icon={ClearIcon}
                    data-test='remove-shipper'
                    label='Remove Shipper'
                    onClick={() => handleRemove(shipper.id)}
                    size='large'
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </>
    )
  }
)
